import axios from 'axios';
import { constructServiceURL } from '../../../../../../utils/URLTools';

const apiFetchBalanceOnHandThresholds = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getYearlyThresholds',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext,
      impcCode: payload.params.impcCode,
    },
  });
  return axios.get(serviceURL);
};

export default apiFetchBalanceOnHandThresholds;
